import React from 'react';

import { LanguageSelect } from '../../components/inputs';

interface AuthPageLayoutProps {
  children: React.ReactNode;
  imageIndex: number;
  imageText: React.ReactNode;
  logo?: string;
  title: React.ReactNode;
  cardClassName?: string;
}

const AuthPageLayout: React.FC<AuthPageLayoutProps> = ({
  children,
  imageIndex,
  imageText,
  logo,
  title,
  cardClassName = 'max-w-[500px]'
}) => {
  const logoSrc = logo || '/img/new-logo.png';

  return (
    <main className="min-h-screen bg-slate-50 lg:grid lg:h-screen lg:overflow-hidden lg:grid-cols-[minmax(560px,65vw)_minmax(320px,35vw)]">
      <section className="relative flex min-h-screen items-center justify-center overflow-x-hidden overflow-y-auto px-5 py-10 sm:px-8 lg:h-screen lg:min-h-0 lg:px-12">
        <div className="absolute -left-24 top-16 h-72 w-72 rounded-full bg-blue-100/60 blur-3xl" />
        <div className="absolute bottom-10 right-16 h-64 w-64 rounded-full bg-slate-200/70 blur-3xl" />

        <div className="absolute right-5 top-5 z-10 sm:right-8 sm:top-8">
          <LanguageSelect />
        </div>

        <div className={`relative z-10 w-full ${cardClassName}`}>
          <div className="rounded-3xl border border-slate-200 bg-white p-8 shadow-xl shadow-slate-200/80 sm:p-10">
            <div className="mb-8">
              <img src={logoSrc} className="max-h-14 max-w-[240px] object-contain" alt="Offshore2go" />
              <div>
                <p className="mt-6 text-xs font-semibold uppercase tracking-[0.28em] text-slate-400">Offshore2go</p>
                <h1 className="mt-2 text-3xl font-bold leading-tight text-slate-950">{title}</h1>
              </div>
            </div>

            {children}
          </div>
        </div>
      </section>

      <aside className="hidden h-screen overflow-hidden lg:block">
        <div className="relative h-full overflow-hidden">
          <img src={`/img/image0${imageIndex}.png`} className="h-full w-full object-cover object-top" alt="" />
          <div className="absolute inset-0 bg-gradient-to-t from-slate-950/75 via-slate-950/15 to-transparent" />
          <p className="absolute bottom-12 left-12 right-12 max-w-md text-[34px] font-bold leading-tight text-white">
            {imageText}
          </p>
        </div>
      </aside>
    </main>
  );
};

export { AuthPageLayout };
